import { API_ROUTES } from '@/constants/api-routes';
import { API_URL_V3 } from '@/constants/constants';
import { QUERY_KEYS } from '@/constants/query-keys';
import { ISignerField } from '@/interfaces/placeholder-field';
import { generateAuthHeaders } from '@/utils/generate-auth-headers';
import axios from 'axios';
import { QueryKey, useQuery, UseQueryOptions } from 'react-query';

export interface IEnvelopeDetails {
  _id: string;
  presignedFileColumnId: string;
  useFileColumn: boolean;
  boardId: string;
  userId: string;
  stripeConfiguration: {
    isPaymentReminderEnabled: boolean;
    statusColumnId: string;
    statusColumnLabel: string;
    transactionIdColumnId: string;
  };
  signerSettings: {
    signers: ISignerField[];
    isSigningOrderRequired: boolean;
  };
  isStripeConnected: boolean;
  permissions: {
    templateGallery: {
      allowNonBoardMembers: boolean;
    };
  };
  signatureCollection: {
    isEnabled: boolean;
    timeZone: string;
  };
  shareAndTrack?: {
    isEnabled?: boolean;
    isEmailVerificationEnabled?: boolean;
  };
  formFiller?: {
    isEnabled: boolean;
  };
}

export const useGetEnvelopeQuery = (
  envelopeId: string,
  options: Omit<
    UseQueryOptions<IEnvelopeDetails, unknown, IEnvelopeDetails, QueryKey>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery<IEnvelopeDetails>(
    [QUERY_KEYS.GET_ENVELOPE_DETAILS, envelopeId],
    async () => {
      const { data } = await axios<IEnvelopeDetails>({
        baseURL: API_URL_V3,
        url: API_ROUTES.GET_ENVELOPE_DETAILS.replace(':envelopeId', envelopeId),
        method: 'GET',
        headers: generateAuthHeaders(),
      });
      return data;
    },
    options,
  );
};
